import Column from '@app/components/layout/Column'
import { DevelopmentFormEdit } from './blocks/livingParameters/DevelopmentFormEdit'
import { HousingFormsEdit } from './blocks/livingParameters/HousingFormsEdit'
import { InterestsEdit } from './blocks/livingParameters/InterestsEdit'
import { EditContainer } from './blocks/shared/EditContainer'
import { TargetGroupsEdit } from './blocks/livingParameters/TargetGroupsEdit'
import { useTranslations } from '@i18n/useLanguage'
import { Text } from '@app/components/core/typography/Text'
import { InitiativeWithId } from '../../../shared/initiativeTypes'

export type LivingParametersEditProps = {
  initiative: InitiativeWithId
}

export const LivingParametersEdit = ({
  initiative,
}: LivingParametersEditProps) => {
  const translationsRoot = useTranslations().app
  const translations = translationsRoot.dashboard.initiative

  const housingForms = initiative.housingForms ?? []
  const targetAudiences = initiative.targetAudiences ?? []
  const interests = initiative.interests ?? []

  return (
    <Column gap={'2rem'} alignItems="stretch" style={{ flexGrow: 0 }}>
      <EditContainer title={translations.view.developmentForm}>
        <EditContainer.View>
          <Text.Medium color="var(--palette-blue-500)">
            {initiative.developmentForm?.name ||
              translations.common.unknownDevelopmentForm}
          </Text.Medium>
        </EditContainer.View>
        <EditContainer.Edit>
          <DevelopmentFormEdit
            initiativeId={initiative.id}
            selectedId={initiative.developmentForm?.id}
          />
        </EditContainer.Edit>
      </EditContainer>
      <EditContainer title={translations.view.housingForms}>
        <EditContainer.View>
          <Text.Medium color="var(--palette-blue-500)">
            {housingForms.length > 0
              ? housingForms.map((f) => f.title).join(', ')
              : translationsRoot.common.notSpecified}
          </Text.Medium>
        </EditContainer.View>
        <EditContainer.Edit>
          <HousingFormsEdit
            initiativeId={initiative.id}
            selectedTags={housingForms.map((f) => f.id)}
          />
        </EditContainer.Edit>
      </EditContainer>
      <EditContainer title={translations.view.targetGroups}>
        <EditContainer.View>
          <Text.Medium color="var(--palette-blue-500)">
            {targetAudiences.length > 0
              ? targetAudiences.map((f) => f.name).join(', ')
              : translationsRoot.common.notSpecified}
          </Text.Medium>
        </EditContainer.View>
        <EditContainer.Edit>
          <TargetGroupsEdit
            initiativeId={initiative.id}
            selectedTags={targetAudiences.map((f) => f.id)}
          />
        </EditContainer.Edit>
      </EditContainer>
      <EditContainer title={translations.view.interests}>
        <EditContainer.View>
          <Text.Medium color="var(--palette-blue-500)">
            {interests.length > 0
              ? interests.map((f) => f.name).join(', ')
              : translationsRoot.common.notSpecified}
          </Text.Medium>
        </EditContainer.View>
        <EditContainer.Edit>
          <InterestsEdit
            initiativeId={initiative.id}
            selectedTags={interests.map((f) => f.id)}
          />
        </EditContainer.Edit>
      </EditContainer>
    </Column>
  )
}
